/**
 * Converte uma cor do padrão RGB para Hexadecimal
 *
 * @param  {int} red   Inteiro referente a posição R
 * @param  {int} green Inteiro referente a posição G
 * @param  {int} blue  Inteiro referente a posição B
 * @return {string}    hexadecimal gerado, ex.: #FF0055
 */
export const rgb2hex = (red, green, blue) => {
  // eslint-disable-next-line no-bitwise
  const rgb = blue | (green << 8) | (red << 16);
  return `${  (0x1000000 + rgb).toString(16).slice(1).toUpperCase()}`;
}

/**
 * Converte uma string de cor para o padrão de cores RGB
 * 
 * @param  {string} hex Hexadecimal de cor
 * @return {Array}      Array contendo a cor no formato RGB
 */
export const hex2rgb = (hex) => {
  // long version
  let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (r) {
    return r.slice(1,4).map((x) => parseInt(x, 16));
  }

  // short version
  r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
  if (r) {
    return r.slice(1,4).map((x) => (0x11 * parseInt(x, 16)) );
  }
  return null;
}
